export default state => state.common.itemsType;
